import React from 'react';
import cx from 'classnames';
// import PropTypes from 'prop-types'
import { useTranslation } from "react-i18next";
import { RewardStyled } from './styled';
import { IMG_PATH } from 'utils/constants/imgPath';

const Reward = ({ theme_standard, src, description }) => {
  const { t } = useTranslation(["common"]);
  const customClass = cx({
    theme_standard: theme_standard,
  });
  return (
    <RewardStyled>
      <div className={customClass}>
        <div className="reward_container">
          <img
            className="rw_img"
            alt="reward img"
            src={src ? IMG_PATH + src : '/assets/images/mockups/reward-1.jpg'}
          />
          <div className="rw_content_block">
            <div className="cb_title">{t("Terms of use", { ns: "common" })}</div>
            <div className="cb_description">{description}</div>
          </div>
        </div>
      </div>
    </RewardStyled>
  );
};

Reward.propTypes = {};

export default Reward;
